import { render, staticRenderFns } from "./ConfigurationCreateUser.vue?vue&type=template&id=046b8680&scoped=true&"
import script from "./ConfigurationCreateUser.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCreateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b8680",
  null
  
)

export default component.exports